import ButtonComponent from './ButtonComponent';
import { saveAs } from "file-saver";
import logo from "../../pages/resources/logo-icon.png";

const ButtonGenerateBaseComponent = (props) => {

    const tbColumns = props.tbColumns
    const tbData = props.tbData
    const lbCustomer = props.lbCustomer
    const lbCategory = props.lbCategory
    const lbMeasurement = props.lbMeasurement
    const wbname = props.wbname

    const createDataExcel = async () => {
        const date = new Date();
        const Excel = require('exceljs');
        const fileName = `${wbname}.xlsx`;
        const wb = new Excel.Workbook();
        const ws = wb.addWorksheet(`${wbname}`);
        const img = wb.addImage({ base64: logo, extension: 'png', })

        const mer = lbMeasurement.map((obj) => { return obj.label; });
        const names = ['date', 'customer', 'category', 'measuraments']
        const titles = ['FECHA     :', 'CLIENTE :', 'CATEGORIA :', 'MEDICIONES  :']

        const ob = []
        ob['date'] = date.toLocaleString();
        ob['customer'] = lbCustomer.label;
        ob['category'] = lbCategory.label;
        ob['measuraments'] = mer.join();

        ws.addImage(img, "B2:B4");
        ws.mergeCells("A1:E5");
        const titleReport = ws.getCell("B7");
        titleReport.font = { name: 'Calibri', family: 4, size: 15, underline: true, bold: true };
        titleReport.value = "PARAMETROS DEL REPORTE";

        for (let i = 0; i < names.length; i++) {
            var r = ws.addRow();
            for (let j = 0; j < 1; j++) {
                let cell = r.getCell(3);
                cell.value = ob[names[i]];
            }
            for (let j = 0; j < 1; j++) {
                let cell = r.getCell(2);
                cell.font = { bold: true }
                cell.value = titles[i];
            }
        }

        const subTitleReport = ws.getCell("B17");
        subTitleReport.font = { name: 'Calibri', family: 4, size: 15, underline: true, bold: true }
        subTitleReport.value = "RESULTADO DEL REPORTE";

        for (var m = 2; m < 20; m++) {
            ws.getColumn(m).width = 20;
        }
        var headersRow = ws.addRow();
        var leftmarginheaders = 2;
        for (let j = 0; j < tbColumns.length; j++) {
            let cell = headersRow.getCell(leftmarginheaders);
            cell.fill = {
                type: 'pattern',
                pattern: 'none',
                bgColor: { argb: '62B682' }
            };
            cell.value = tbColumns[j]['name'];
            leftmarginheaders++
        }
        for (let i = 0; i < tbData.length; i++) {
            var leftmargindata = 2;
            var dataRow = ws.addRow();
            for (let j = 0; j < tbColumns.length; j++) {
                let cell = dataRow.getCell(leftmargindata);
                cell.value = tbData[i][tbColumns[j]['name']];
                leftmargindata++
            }
        }

        wb.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
                new Blob([buffer], { type: "application/octet-stream" }), fileName
            )
        })
    }
    return (
        <ButtonComponent onClick={createDataExcel} className=" px-4 py-1 bg-orange-400 rounded-md font-medium text-white ">
            {props.name}
        </ButtonComponent>
    )
}
export default ButtonGenerateBaseComponent;